"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OfferHintWrapper = exports.Content = void 0;
var _mui = require("@ori-ui/mui");
const OfferHintWrapper = exports.OfferHintWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        borderRadius: theme.shape.largeComponentRadius,
        boxSizing: 'border-box',
        paddingBottom: theme.spacing(6),
        overflow: 'hidden',
        position: 'relative',
        [theme.breakpoints.only('xs')]: {
            paddingBottom: theme.spacing(3),
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        }
    };
});
const Content = exports.Content = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        background: theme.palette.background.paper,
        borderRadius: theme.shape.largeComponentRadius,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        position: 'relative',
        [theme.breakpoints.only('xs')]: {
            borderRadius: 0
        }
    };
});
